import React, {FC, ReactNode} from "react"
import {Navigate, useLocation} from 'react-router-dom'
import {useAuth} from "../providers/AuthProvider";
import {AuthState, RoutePath, RouteRestriction} from "../enums";

interface IAuthGuardProps {
    children: ReactNode;
    restriction: RouteRestriction;
}

export const AuthGuard: FC<IAuthGuardProps> = ({restriction, children}) => {
    const {authState} = useAuth();
    const location = useLocation();
    const isAuthorized = (restriction === RouteRestriction.ADMIN_ONLY && authState === AuthState.ADMIN) ||
        (restriction === RouteRestriction.CUSTOMER_ONLY && authState === AuthState.CUSTOMER);

    return isAuthorized ?
        <>{children}</> :
        <Navigate to={location.pathname === RoutePath.ADMIN_PORTAL ? RoutePath.ADMIN_SIGN_IN : RoutePath.SIGN_IN}
                  replace/>;
}